
import React from "react";
import "../ASSETS/css/main.css";

import logo from "../../src/ASSETS/images/logo-starken.png";
import { Container } from "react-bootstrap";

export default function View404() {
  return (
    <Container className="containerPrincipal shadow rounded" style={{ background: "white" }}>
      <Container className="containerSecundario">

        <Container style={{ marginBottom: 20 }}>
          <img alt="banner" src={logo} />
        </Container>


        <Container style={{ marginBottom: 20 }}>
          <h2>Error 404</h2>
          <h5>La dirección no Existe.</h5>
        </Container>

      </Container>
    </Container>
  );
}
